<template>
    <SectionBasicLayout
      title='settings.smokescreen_addresses.title.add_new'
      content_class="email-obfuscation"
      close_route="smokescreen-addresses-list"
      >
        <template #actions>
            <ActionButton
                @click='onAddSender()'
                icon="fas fa-save"
                :loading=smokescreen_controller.content_state.saving
                v-tooltip='"global.actions.save_changes"'
                :gtm="{
                    module : 'smokescreen_settings',
                    feature: 'smokescreen_form',
                    block  : `top_actions`,
                    action : 'submit'
                }"
            />
        </template>

        <template #content>
            <form>
                <fieldset class="bottom-space column-group">
                    <legend class="column-100">
                        {{Language.say('settings.smokescreen_addresses.legends.add_address')}}
                    </legend>

                    <InputText
                        :input_focus=true
                        :input_id="`smsc_prefix_01`"
                        :input_name="'prefix'"
                        :input_invalids="properties_validation.invalid"
                        :input_value="prefix"
                        v-model:input_value="prefix"
                        :label_text="'settings.smokescreen_addresses.labels.prefix'"
                        :error_text="'settings.smokescreen_addresses.errors.prefix'"
                        @keydown.enter.prevent='onAddSender()'
                        class="column-100"
                    />
                </fieldset>

                <ContainerAlert
                    type="info"
                >
                    {{Language.say('settings.smokescreen_addresses.notices.create_new')}}
                </ContainerAlert>

                <div class="submit-desktop">
                    <ActionButton
                        @click='onAddSender()'
                        class="main-action"
                        icon="fas fa-save"
                        text="global.actions.submit"
                        :loading=smokescreen_controller.content_state.saving
                        :gtm="{
                            module : 'smokescreen_settings',
                            feature: 'smokescreen_form',
                            block  : `bottom_actions`,
                            action : 'submit'
                        }"
                    />
                </div>
            </form>
        </template>
    </SectionBasicLayout>
</template>

<script setup>
    import {reactive,  ref}      from 'vue';
    import {useRouter}           from 'vue-router';
    import ActionButton          from '@/vue/Elements/Buttons/ActionButton.vue';
    import SectionBasicLayout    from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
    import InputText             from '@/vue/Elements/Inputs/InputText.vue';
    import ContainerAlert        from '@/vue/Elements/Content/ContainerAlert.vue';
    import Language              from '@/js/Shared/Language/Language.js';
    import SmokescreenController from '@/js/Settings/Smokescreen/SmokescreenController';
    import PropertiesValidation  from '@/js/Shared/Validation/PropertiesValidation';

    const props = defineProps({
        smokescreen_controller: SmokescreenController,
    });

    const prefix                = ref('');
    const properties_validation = reactive(new PropertiesValidation({
        'prefix': {
            required       : true,
            regex          : 'alphanumeric',
            min_length     : 3,
            max_length     : 30,
        },
    }));

    const router = useRouter();

    const onAddSender = async () => {
        properties_validation.reset();

        if (!properties_validation.validateField('prefix', prefix.value)) {
            return;
        }

        await props.smokescreen_controller.addSmokescreenAddress(prefix.value);

        router.push(
            { name: 'smokescreen-addresses-list' }
        );
    }
</script>
